import React, { createContext, useContext, useState, useEffect } from "react";

const isBrowser = typeof window !== "undefined";

// Applies theme to DOM immediately — prevents flash between route transitions
export const applyBodyTheme = (isDark: boolean) => {
  if (!isBrowser) return;
  document.body.style.background = isDark ? "#141414" : "";
  document.body.style.backgroundColor = isDark ? "#141414" : "";
  document.documentElement.style.setProperty(
    "--bs-card-bg",
    isDark ? "rgba(20, 20, 20, 0.98)" : "",
  );
  document.documentElement.style.setProperty(
    "--bs-body-bg",
    isDark ? "#141414" : "",
  );
};

const GlobalThemeContext = createContext<boolean>(false);

export const useGlobalTheme = () => useContext(GlobalThemeContext);

export const GlobalThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isDark, setIsDark] = useState(() => {
    if (!isBrowser) return false;
    const initial = localStorage.getItem("theme") === "dark";
    applyBodyTheme(initial);
    return initial;
  });

  useEffect(() => {
    if (!isBrowser) return;
    const handler = (e: Event) => {
      const dark = (e as CustomEvent).detail.isDark as boolean;
      setIsDark(dark);
      applyBodyTheme(dark);
    };
    window.addEventListener("appThemeChange", handler);
    return () => window.removeEventListener("appThemeChange", handler);
  }, []);

  return (
    <GlobalThemeContext.Provider value={isDark}>
      {children}
    </GlobalThemeContext.Provider>
  );
};
